module.exports = __webpack_public_path__ + "img/404.972042a0.png";